import React from "react";
import {
  Card,
  CardContent,
  Typography,
  Box,
  Grid,
  Tooltip,
  Fab,
  Divider
} from "@mui/material";
import { IconButton } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import ModeIcon from "@mui/icons-material/Mode";
import DeleteIcon from "@mui/icons-material/Delete";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import HowToRegIcon from "@mui/icons-material/HowToReg";

const JobCard = ({
  job,
  user,
  searchParams,
  applyJob,
  handleView,
  handleEdit,
  updateIsActive,
  MyCopyFunction
}) => {
  return (
    <Card
      sx={{
        height: 600,
        position: "relative",
        display: "flex",
        flexDirection: "column",
        borderRadius: 3,
        boxShadow: 3,
        transition: "0.3s",
        "&:hover": {
          boxShadow: 10,
          transform: "translateY(-6px)"
        },
        "&:hover .fab-actions": {
          opacity: 1,
          bottom: 16
        }
      }}
    >
      {/* HEADER */}
      <Box
        sx={{
          background: "linear-gradient(135deg,#3f51b5,cornflowerblue)",
          color: "#fff",
          p: 2,
          textAlign: "left"
        }}
      >
        <Typography variant="h6" fontWeight="bold">
          {job.companyname}
        </Typography>
        <Typography variant="body2">{job.officeName + (job.languages?(" - (" + job.languages+")"):"")}</Typography>
      </Box>

      {/* CONTENT */}
    <CardContent sx={{ flex: 1, overflowY: "auto", p: 3 }}>
  <Typography variant="subtitle1" fontWeight="600" sx={{ mb: 1 }}>
    {job.jobtitle} <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
    SPOC: {job.spocName || "-"}
  </Typography>
  </Typography>

 

  <Typography variant="body2" sx={{ mb: 2, fontWeight: "bold" }}>
    Experience: {Math.floor(job.minexpmonths / 12)} Yr {job.minexpmonths % 12}{" "}
    Mn – {Math.floor(job.maxexpmonths / 12)} Yr {job.maxexpmonths % 12} Mn
  </Typography>

  <Divider sx={{ mb: 2 }} />

  {/* Job Description header + copy */}
  <Box
  sx={{
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    mb: 1,
    userSelect: "none",
  }}
>
  <Typography variant="body1" fontWeight="bold" sx={{ textAlign: "left" }}>
    Job Description:
  </Typography>

  {user.accesstype !== "c" && (
    <Tooltip title="Copy Job Description">
      <IconButton
        size="small"
        color="primary"
        onClick={() => MyCopyFunction("Job Description:\n" + job.jobdescription)}
        aria-label="copy job description"
        sx={{
          ml: 1,
          p: 0.5,
          transition: "background-color 0.3s",
          "&:hover": {
            backgroundColor: "rgba(63, 81, 181, 0.15)", // light primary tint
          },
        }}
      >
        <ContentCopyIcon fontSize="small" />
      </IconButton>
    </Tooltip>
  )}
</Box>

  <Typography
    variant="body2"
    sx={{
      whiteSpace: "pre-line",
      textAlign: "left",
      mb: 3,
      lineHeight: 1.5,
      color: "text.primary"
    }}
  >
    {job.jobdescription}
  </Typography>

  {/* Key Skills header + copy */}
  <Box
  sx={{
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    mb: 1,
    userSelect: "none",
  }}
>
  <Typography variant="body1" fontWeight="bold" sx={{ textAlign: "left" }}>
    Key Skills:
  </Typography>

  {user.accesstype !== "c" && (
    <Tooltip title="Copy Key Skills">
      <IconButton
        size="small"
        color="primary"
        onClick={() => MyCopyFunction("Key Skills:\n" + job.skills)}
        aria-label="copy key skills"
        sx={{
          ml: 1,
          p: 0.5,
          transition: "background-color 0.3s",
          "&:hover": {
            backgroundColor: "rgba(63, 81, 181, 0.15)", // light primary tint
          },
        }}
      >
        <ContentCopyIcon fontSize="small" />
      </IconButton>
    </Tooltip>
  )}
</Box>

  <Typography
    variant="body2"
    sx={{
      whiteSpace: "pre-line",
      textAlign: "left",
      color: "text.primary",
      lineHeight: 1.5
    }}
  >
    {job.skills}
  </Typography>
</CardContent>


      {/* FLOATING FAB ACTIONS */}
      <Box
        className="fab-actions"
        sx={{
          position: "absolute",
          bottom: -20,
          left: "50%",
          transform: "translateX(-50%)",
          display: "flex",
          gap: 1,
          opacity: 0,
          transition: "0.3s",
          zIndex: 10
        }}
      >
        {((searchParams && searchParams.get("applicantid")) ||
          user.accesstype === "c") && (
          <Tooltip title="Apply">
            <Fab size="small" color="success" onClick={() => applyJob(job)}>
              <HowToRegIcon />
            </Fab>
          </Tooltip>
        )}

        {user.accesstype !== "c" && (
          <Tooltip title="View">
            <Fab size="small" color="primary" onClick={() => handleView(job)}>
              <VisibilityIcon />
            </Fab>
          </Tooltip>
        )}

        {(user.accesstype >= 3 || job.spocId === user._id) && (
          <Tooltip title="Edit">
            <Fab size="small" color="secondary" onClick={() => handleEdit(job)}>
              <ModeIcon />
            </Fab>
          </Tooltip>
        )}

        {user.accesstype >= 3 && (
          <Tooltip title="Delete">
            <Fab
              size="small"
              color="error"
              onClick={() => updateIsActive(job)}
            >
              <DeleteIcon />
            </Fab>
          </Tooltip>
        )}
      </Box>
    </Card>
  );
};

export default JobCard;
